import { useSocketInitializer } from './useSocketInitializer';
import { useNotificationSocket } from './notifications';
import { useScheduleNoteSocket } from './scheduleNote';
import { useTermsOfUseSocket } from './termsOfUse';
import { useOrganizationUsersSocket } from './users';
import { useInvitationSocket } from './invitation';
import { useScheduleSocket } from './schedule';

export function useAppSockets() {
  useSocketInitializer();
  useInvitationSocket();
  useOrganizationUsersSocket();
  useNotificationSocket();
  useScheduleSocket();
  useScheduleNoteSocket();
  useTermsOfUseSocket();
}
